export enum projectType {
  eHukumat = 'eHukumat',
  eDo = 'eDo'
}

export enum operatorRole {
  ADMIN = "ADMIN",
  OPERATOR = "OPERATOR",
  SUPER_ADMIN = "SUPER_ADMIN",
  DEV ="DEV",
  CENTER_OPERATOR = "CENTER_OPERATOR"
}

export interface IOperator {
  id: string;
  login: string;
  name: string;
  role: operatorRole;
  project: projectType;
}

export interface ICreateOperator {
  login: string;
  name: string;
  password: string;
  project: projectType;
  role: operatorRole
}

export interface ICreateUser {
  telegramId?: string;
  name: string;
  phone: string;
}

export interface ICreateMessage {
  userId?: string;
  operatorId?: string;
  content: string;
  ticketId: number; 
}


export interface IUpdateOperator {
  login?: string;
  name?: string;
  password?: string;
}
